import {
  CircleCheck,
  CircleX,
  Info,
  LoaderCircle,
  TriangleAlert,
} from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      closeButton
      richColors
      theme="dark"
      position="top-center"
      className="toaster"
      icons={{
        error: <CircleX className="size-4" />,
        info: <Info className="size-4" />,
        loading: <LoaderCircle className="size-4 animate-spin" />,
        success: <CircleCheck className="size-4" />,
        warning: <TriangleAlert className="size-4" />,
      }}
      toastOptions={{
        classNames: {
          actionButton: "!bg-primary !text-primary-foreground",
          cancelButton: "!bg-secondary !text-secondary-foreground",
          description: "!text-foreground-muted",
          error: "!border-danger/70",
          success: "!border-success/70",
          toast:
            "!border-border !bg-surface-raised !text-foreground !shadow-[var(--shadow-overlay)]",
          warning: "!border-warning/70",
        },
      }}
      {...props}
    />
  );
}
